// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_s9-0";